import { AssessmentDescriptor } from '@amzn/aws-assessment-template-management-service-typescript-client';
import { SpaceBetween } from '@amzn/awsui-components-react';
import { FunctionComponent } from 'react';

import { EditableDescriptorKey } from '../../../../../api/templateManagement/TemplateManagementClient';
import TemplateEditableText from '../../../../common/TemplateEditableText';

type AssessmentPromptEditableSelectGroupProps = {
    selectionDescriptionDescriptor: AssessmentDescriptor;
    selectionDescriptors: AssessmentDescriptor[];
};

/**
 * This component displays all selections for editing
 * In the future, this component will support adding and removing selections
 */
const AssessmentPromptEditableSelectGroup: FunctionComponent<AssessmentPromptEditableSelectGroupProps> = ({
    selectionDescriptionDescriptor,
    selectionDescriptors,
}): JSX.Element => {
    return (
        <SpaceBetween size='s' direction='vertical'>
            <TemplateEditableText
                key={0}
                descriptor={selectionDescriptionDescriptor}
                keyToEdit={EditableDescriptorKey.Description}
                fieldName={'Selection description'}
                numRows={1}
            />
            {selectionDescriptors.map((descriptor, index) => {
                return (
                    <TemplateEditableText
                        key={index + 1}
                        descriptor={descriptor}
                        keyToEdit={EditableDescriptorKey.Description}
                        numRows={1}
                        fieldName={`Selection ${index + 1}`}
                    />
                );
            })}
        </SpaceBetween>
    );
};

export default AssessmentPromptEditableSelectGroup;
